import { type FlowError } from '@ory/client-fetch';
import { Error } from '@ory/elements-react/theme';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { z } from 'zod';

import { oryComponentOverrides } from '@apps/web/components/auth/ory_components';
import { useOry } from '@apps/web/hooks/ory';

export const Route = createFileRoute('/_auth/error')({
    component: ErrorPage,
    validateSearch: z.object({
        id: z.string().optional(),
    }),
});

function ErrorPage() {
    const { id: errorId } = Route.useSearch();
    const router = useRouter();
    const [error, setError] = useState<FlowError | null>(null);
    const { oryClient, oryElementsConfiguration, normalizeOryPayload } =
        useOry();

    useEffect(() => {
        (async () => {
            try {
                if (errorId) {
                    const error = normalizeOryPayload(
                        await oryClient.getFlowError({ id: errorId }),
                    );
                    setError(error);
                }
            } catch (error) {
                console.error(error);
            }
        })();
    }, [errorId, normalizeOryPayload, oryClient, router]);

    if (!error) {
        return null;
    }

    return (
        <div className="ory-root w-full max-w-xl">
            <Error
                error={error}
                config={oryElementsConfiguration}
                components={oryComponentOverrides}
            />
        </div>
    );
}
